import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IConfiguredServicesDataTableRowFormMeta {
    
    // Table modal form fields
    fdk: FormInputMeta;
    offeredServices: FormInputMeta;
    transactionType: FormInputMeta;
    p1: FormInputMeta;
    p2: FormInputMeta;
    p3: FormInputMeta;
    p4: FormInputMeta;
    p5: FormInputMeta;
    p6: FormInputMeta;
    p7: FormInputMeta;
    p8: FormInputMeta;

    schema: any;
}

const configuredServicesDataTableRowFormMeta = {} as IConfiguredServicesDataTableRowFormMeta;

// Table modal form fields
configuredServicesDataTableRowFormMeta.fdk = {
    name: "fdk",
    type: "text",
    label: "Fdk",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire"),
};

configuredServicesDataTableRowFormMeta.offeredServices = {
    name: "offeredServices",
    type: "select",
    label: "Offered Service",
    placeholder: "",
    validation: yup.string(),
};
    
configuredServicesDataTableRowFormMeta.transactionType = {
    name: "transactionType",
    type: "text",
    label: "Transaction Type",
    placeholder: "",
    validation: yup.string(),
};
    
configuredServicesDataTableRowFormMeta.p1 = {
    name: "p1",
    type: "text",
    label: "P1",
    placeholder: "",
    validation: yup.string(),
};

configuredServicesDataTableRowFormMeta.p2 = {
    name: "p2",
    type: "text",
    label: "P2",
    placeholder: "",
    validation: yup.string(),
};

configuredServicesDataTableRowFormMeta.p3 = {
    name: "p3",
    type: "text",
    label: "P3",
    placeholder: "",
    validation: yup.string(),
};

configuredServicesDataTableRowFormMeta.p4 = {
    name: "p4",
    type: "select",
    label: "P4",
    placeholder: "",
    validation: yup.string(),
};

configuredServicesDataTableRowFormMeta.p5 = {
    name: "p5",
    type: "select",
    label: "P5",
    placeholder: "",
    validation: yup.string(),
};

configuredServicesDataTableRowFormMeta.p6 = {
    name: "p6",
    type: "select",
    label: "P6",
    placeholder: "",
    validation: yup.string(),
};

configuredServicesDataTableRowFormMeta.p7 = {
    name: "p7",
    type: "text",
    label: "P7",
    placeholder: "",
    validation: yup.string(),
};

configuredServicesDataTableRowFormMeta.p8 = {
    name: "p8",
    type: "select",
    label: "P8",
    placeholder: "",
    validation: yup.string(),
};

configuredServicesDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(configuredServicesDataTableRowFormMeta));

export default configuredServicesDataTableRowFormMeta;